import React from "react";
import PopularMovie from "../api/Popular";
import PaginatedMovieGrid from "./PaginatedMovieGrid";

const PopularMovAll = () => (
  <PaginatedMovieGrid title="Popular Movies" fetcher={PopularMovie} />
);

export default PopularMovAll;
